import React, { Fragment } from "react";
import { t } from "ttag";

import { FooterLegalText } from "@reactivated";

import { ReactivatedContext as Context } from "../../context";
import { Clickable } from "../Clickables";
import { RichText } from "../RichText";

import styles from "./FooterLegal.module.scss";

export const FooterLegal = (props: { value: FooterLegalText }) => {
    const context = React.useContext(Context);
    const footerLogo = context.core_assets.logo_inverted;

    return (
        <div className={styles.legalContainer}>
            <img src={footerLogo} className={styles.footerLogo} alt={t`SKS`} />
            {props.value.copyright && (
                <RichText
                    className={styles.footerCopyright}
                    value={props.value.copyright}
                />
            )}
            <div className={styles.legalLinks}>
                {props.value.links?.map((link, l) =>
                    link.url ? (
                        <Clickable
                            key={l}
                            href={link.url}
                            className={styles.link}
                        >
                            {link.display_name}
                        </Clickable>
                    ) : (
                        <Fragment key={l}></Fragment>
                    ),
                )}
                <Clickable
                    onPress={() =>
                        window.transcend?.showConsentManager({
                            viewState: "DoNotSellExplainer",
                        })
                    }
                    className={styles.link}
                >
                    {t`Do Not Sell or Share`}
                </Clickable>
            </div>
            {props.value.accessibility && (
                <RichText
                    className={styles.footerAccessibility}
                    value={props.value.accessibility}
                />
            )}
        </div>
    );
};
